<template>
    <div>
        <div class="q-gutter-md row justify-start q-carousel__navigation-inner row items-center">
            <p style="color: #564254; font-size: 22px; font-weight: bold; padding: 20px;">E-Learning</p>
            <q-btn-dropdown v-if="isAdmin" color="primary" label="Add Video" style="margin-top: -5px;">
                <q-list>
                    <q-item clickable v-close-popup @click="upload = true; videoType = 'local'">
                    <q-item-section>
                        <q-item-label>Upload Video</q-item-label>
                    </q-item-section>
                    </q-item>

                    <q-item clickable v-close-popup @click="prompt = true; videoType = 'yt'"> 
                    <q-item-section>
                        <q-item-label>Add Youtube Link</q-item-label>
                    </q-item-section>
                    </q-item>
                </q-list>
            </q-btn-dropdown>

            <q-dialog v-model="upload">
                <q-card style="min-width: 350px">
                    <q-card-section>
                    <div class="text-h6">Upload Video</div>
                    </q-card-section>

                    <q-card-section class="q-pt-none" style="margin-bottom: 10px;">
                        <q-input dense v-model="lessonName" autofocus @keyup.enter="upload = false" label="Title"/>
                    </q-card-section>

                    <q-card-section class="q-pt-none">
                        <q-input dense v-model="details" autofocus @keyup.enter="upload = false" label="Video Details"/>
                    </q-card-section>

                    <div class="center">
                        <label class="custom-file-upload" for="file" @change="getVideo($event)">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="" viewBox="0 0 24 24"><g stroke-width="0" id="SVGRepo_bgCarrier"></g><g stroke-linejoin="round" stroke-linecap="round" id="SVGRepo_tracerCarrier"></g><g id="SVGRepo_iconCarrier"> <path fill="" d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z" clip-rule="evenodd" fill-rule="evenodd"></path> </g></svg>
                            </div>
                            <div class="text">
                                <span>{{ fileName === '' ? 'Click to upload video' : fileName}}</span>
                            </div>
                            <input type="file" id="file" accept="video/*" />
                        </label>
                    </div>

                    <q-card-actions align="right" class="text-primary">
                    <q-btn flat label="Cancel" v-close-popup @click="lessonName = ''; youtubeUrl = ''; details = ''; localUrl = '';" />
                    <q-btn flat label="Add Video" v-close-popup @click="uploadToLocal()" />
                    </q-card-actions>
                </q-card>
            </q-dialog>

            <q-dialog v-model="prompt">
                <q-card style="min-width: 350px">
                    <q-card-section>
                    <div class="text-h6">Enter Video Details</div>
                    </q-card-section>

                    <q-card-section class="q-pt-none" style="margin-bottom: 10px;">
                        <q-input dense v-model="lessonName" autofocus @keyup.enter="prompt = false" label="Title"/>
                    </q-card-section>

                    <q-card-section class="q-pt-none">
                        <q-input dense v-model="youtubeUrl" autofocus @keyup.enter="prompt = false" label="Youtube Embed youtube"/>
                    </q-card-section>

                    <q-card-section class="q-pt-none">
                        <q-input dense v-model="details" autofocus @keyup.enter="prompt = false" label="Video Details"/>
                    </q-card-section>

                    <q-card-actions align="right" class="text-primary">
                    <q-btn flat label="Cancel" v-close-popup @click="lessonName = ''; youtubeUrl = ''; details = '';" />
                    <q-btn flat label="Add Video" v-close-popup @click="createLesson()" />
                    </q-card-actions>
                </q-card>
            </q-dialog>
        </div>
        <div class="center">
            <div v-if="lessons.length === 0" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; font-size: 20px;">
                <p>No data available.</p>
            </div>
            <main v-for="lesson in lessons" :key="lesson.id" class="container1">
                <div class="container2">
                    <div v-if="lesson.youtube_url">
                        <iframe class="video" width="400" height="240" frameBorder="0" allow="fullscreen;" :src="lesson.youtube_url"></iframe>
                    </div>
                    <div v-else>
                        <video width="400" height="240" :src="apiUrl + lesson.local_url" preload="none" loading="lazy" muted="false" loop="false" controls></video>
                    </div>
                </div>
                <div style="margin-top: 5px; font-size: 16px; font-weight: 500;">
                    <p class="text">{{ lesson.lesson_name }}</p>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import vueCookies from 'vue-cookies';

export default {
	data () {
		return {
           lessons: [],
           prompt: false,
           upload: false,
           lessonName: '',
           youtubeUrl: null,
           details: '',
           localUrl: null,
           isAdmin: false,
           fileName: '',
	    }
	},

	created(){
		this.getLessons()
        this.checkPermissions()
	},
    
	methods: {
        checkPermissions(){
            if(vueCookies.get('sgcchris').user.role_id === 1){
                this.isAdmin = true;
            }
        },

	    getLessons() {
	        axios.get(this.apiUrl + '/lessons', {
	            headers: { 'Authorization': `Bearer ${this.token}` },
	        }).then((response) => {
	            this.lessons = response.data.data
            	console.log('data:' + JSON.stringify(this.lessons))
				this.loading = false
	        }).catch((error) => {
	            console.log(error);
	        })
	   },

       getVideo(event){
            this.localUrl = event.target.files[0];
            this.fileName = event.target.files[0].name;
       },

       createLesson() {
            let formData = new FormData();
            formData.append("lessonName", this.lessonName);
            formData.append("youtubeUrl", this.youtubeUrl);
            formData.append("details", this.details);
            formData.append("video", this.localUrl);
            // formData.append("video_type", this.videoType);

            axios.create({
                baseURL: this.apiUrl,
                headers: { 'Authorization': `Bearer ${this.token}` }
            }).post('/create/yt/lesson', formData)
            .then((res) => {
                this.lessonName = ''
                this.youtubeUrl = null
                this.details = ''
                this.localUrl = null

                this.getLessons()

                this.$q.notify({
                    progress: true,
                    message: `Video Added Successfully.`,
                    color: 'green'
                }, 2000)

                // console.log(res.data.url)
            }).catch((error) => {
                this.lessonName = ''
                this.youtubeUrl = null
                this.details = ''
                this.localUrl = null

                this.$q.notify({
                    progress: true,
                    message: `Something went wrong.`,
                    color: 'red'
                }, 2000)
                console.log(error)
            });
       },

       uploadToLocal() {
        if(this.lessonName === '' || this.details === '' || this.localUrl === null){
            this.$q.notify({
                progress: true,
                message: `Please fill all the fields.`,
                color: 'red'
            }, 2000)
        }else{
            let formData = new FormData();
            formData.append("lessonName", this.lessonName);
            formData.append("youtubeUrl", null);
            formData.append("details", this.details);
            formData.append("video", this.localUrl);

            axios.create({
                baseURL: this.apiUrl,
                headers: { 'Authorization': `Bearer ${this.token}`, 'Content-Type': 'multipart/form-data' }
            }).post('/create/local/lesson', formData)
            .then((res) => {
                this.lessonName = ''
                this.youtubeUrl = null
                this.details = ''
                this.localUrl = null

                this.getLessons()

                this.$q.notify({
                    progress: true,
                    message: `Video Added Successfully.`,
                    color: 'green'
                }, 2000)

                // console.log(res.data.url)
            }).catch((error) => {
                this.lessonName = ''
                this.youtubeUrl = null
                this.details = ''
                this.localUrl = null

                this.$q.notify({
                    progress: true,
                    message: `Something went wrong.`,
                    color: 'red'
                }, 2000)
                console.log(error)
            });
        }
            
       },
	}
}
</script>

<style scoped>
.center{
    display: flex;
    align-content: center;
    justify-content: start;
    width: 100%;
    gap: 50px;
    padding-left: 50px;
    padding-right: 50px;
    flex-wrap: wrap;
}

.container1 {
    width: 400px;
    height: 240px;
}

.container2 {
    width: 400px;
    height: 240px;
    background: black;
    display: block;
    overflow: hidden;
    border-radius: 25px;
    transform: translateZ(0px);
    position: relative;
}

.text {
    text-align: center;
    color: black;
}

.custom-file-upload {
  height: 200px;
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: space-between;
  gap: 20px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border: 2px dashed #cacaca;
  background-color: rgba(255, 255, 255, 1);
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0px 48px 35px -48px rgba(0,0,0,0.1);
}

.custom-file-upload .icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-file-upload .icon svg {
  height: 80px;
  fill: rgba(75, 85, 99, 1);
}

.custom-file-upload .text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-file-upload .text span {
  font-weight: 400;
  color: rgba(75, 85, 99, 1);
}

.custom-file-upload input {
  display: none;
}
</style>